import { __extends } from "tslib";
import { IgrStrategyBasedIndicator } from "./igr-strategy-based-indicator";
import { FastStochasticOscillatorIndicator } from "./FastStochasticOscillatorIndicator";
/**
 * Represents a IgxDataChartComponent Fast Stochastic Oscillator indicator series.
 * Default required members: High, Low, Close
*/
var IgrFastStochasticOscillatorIndicator = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(IgrFastStochasticOscillatorIndicator, _super);
    function IgrFastStochasticOscillatorIndicator(props) {
        return _super.call(this, props) || this;
    }
    IgrFastStochasticOscillatorIndicator.prototype.createImplementation = function () {
        return new FastStochasticOscillatorIndicator();
    };
    Object.defineProperty(IgrFastStochasticOscillatorIndicator.prototype, "i", {
        /**
                                     * @hidden
                                     */
        get: function () {
            return this._implementation;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrFastStochasticOscillatorIndicator.prototype, "period", {
        /**
         * Gets or sets the moving average period for the current FastStochasticOscillatorIndicator object.
         * The typical, and initial, value for FastStochasticOscillatorIndicator periods is 14.
        */
        get: function () {
            return this.i.u6;
        },
        set: function (v) {
            this.i.u6 = +v;
        },
        enumerable: false,
        configurable: true
    });
    return IgrFastStochasticOscillatorIndicator;
}(IgrStrategyBasedIndicator));
export { IgrFastStochasticOscillatorIndicator };
